import React from 'react'
import {SvgIcon} from 'rambler-ui'

export default function ArrowRightIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 15 15">
      <path d="M9.54 7.5l-5.193 5.194a.497.497 0 0 0 .006.7l.213.213a.499.499 0 0 0 .7.005l5.41-5.408a.992.992 0 0 0 0-1.408l-5.41-5.408a.497.497 0 0 0-.7.005l-.213.214a.499.499 0 0 0-.006.7L9.54 7.5z" />
    </SvgIcon>
  )
}
